import React from "react";
import { PopupButton, } from "react-calendly";
import { GoogleAnalyticsEnum, triggerFunction } from "../../utils/google-analytics";

const CalendlyPopupButton = ({ btnText, color="#F86F03", className="edu-btn btn-medium btn-dark mb-0" }) => {
    const REACT_APP_CALENDLY_LINK = process.env.REACT_APP_CALENDLY_LINK;
    return (
        <div className="App">
            <PopupButton
                url={REACT_APP_CALENDLY_LINK}
                /*
                 * react-calendly uses React's Portal feature (https://reactjs.org/docs/portals.html) to render the popup modal. As a result, you'll need to
                 * specify the rootElement property to ensure that the modal is inserted into the correct domNode.
                 */
                rootElement={document.getElementById("root")}
                text={btnText}
                textColor="#6F6B80"
                onClick={() => triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.BOOK_SESSION)}
                color={color}
                className={className}
            />
        </div>
    );
};

export default CalendlyPopupButton;